import { BOA_KEY, rsUrls, VERSION } from "../../constants/ApiUrls";
import {
  deleteData,
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getAllRSUsers = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${rsUrls.GET_ALL_RS_USERS}`);
};

export const getRSCategoryList = async () => {
  return await getData(BOA_KEY + VERSION + rsUrls.GET_RS_CATEGORY_LIST);
};

export const addRSUsers = async (data) => {
  return await postData(BOA_KEY + VERSION + rsUrls.SAVE_RS_USER, data);
};

export const removeRSUser = async (key) => {
  return await deleteData(BOA_KEY + VERSION + rsUrls.DELETE_RS_USER, key);
};

export const updateRSUser = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${rsUrls.UPDATE_RS_USER}`,
    data
  );
};

export const getTotalAssetsValue = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/total-assets-value`);
};
